export default __webpack_public_path__ + "static/media/isf-light.b35c522d.svg";